var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDraftFile = function SvgDraftFile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.714-.001A1.714 1.714 0 0 0 0 1.713v8.572a1.714 1.714 0 0 0 1.714 1.714h6.857a1.714 1.714 0 0 0 1.715-1.714V4.034a.86.86 0 0 0-.251-.606L6.857.25A.86.86 0 0 0 6.251 0zM6 .856v2.572a.857.857 0 0 0 .857.857H9.43z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 11,
    r: 3.5,
    fill: "#6F6CFA",
    stroke: "#161729"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDraftFile);
export { ForwardRef as ReactComponent };